// extracted by mini-css-extract-plugin
export default {"contentfulHeroContainer":"ContentfulHero-module__contentfulHeroContainer--F2MDp","heroVideo":"ContentfulHero-module__heroVideo--ee6i5"};